// extracted by mini-css-extract-plugin
export var orderPrice = "OrderPrice-module--order-price--3haVQ";